module.exports = __webpack_public_path__ + "static/media/US.aa8494f7.svg";